module.exports = __webpack_public_path__ + "static/media/GraviolaSoft-MediumItalic.e8d590f2.otf";